import styled from 'styled-components'
import { colors, cyberColors } from '../../../../../lib/colors'

export const SwitcherWrapper = styled.div`
  position: relative;
`
export const SwitcherBox = styled.div`
  width: 36px;
  height: 16px;
  border-radius: 100px;
  background: ${colors.darkGreyBorder};
  z-index: -1;
  margin-right: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
export const SwitcherCheck = styled.div<{ checked: boolean }>`
  height: 12px;
  width: 12px;
  transform: ${({ checked }) =>
    checked ? 'translateX(4px)' : 'translateX(-12px)'};
  margin: 0 8px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
  background: ${({ checked }) =>
    checked ? cyberColors.blueGradient : cyberColors.redGradient};
  z-index: 1;
`
export const SwitcherArea = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  z-index: 100;
`
